<template>
  <div class="ad-group-wrap">
    <div class="card-header">推广计划</div>
    <div class="newgroup-wrap" style="padding-top: 20px" v-show="dialogVisible">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">推广目标：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.promotedObjectType" @change="changeSpreadTarget">
                <el-radio label="APP_IOS">iOS 应用</el-radio>
                <el-radio label="APP_ANDROID">Android 应用</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">推广计划：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.campaignMode" @change="changeCampaignMode">
                <el-radio label="add">新建推广计划</el-radio>
                <el-radio label="edit">已有推广计划</el-radio>
              </el-radio-group>
            </div>
          </li>
          <div v-if="formData.campaignMode === 'add'">
            <li class="form-item">
              <span class="form-label">推广计划名称：</span>
              <div class="form-value">
                <select-input
                  ref="selectInputRef"
                  placeholder="(必填)请输入推广计划名称"
                  :dataList="showAdList"
                  v-model="formData.nameRule"
                ></select-input>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">投放方式：</span>
              <div class="form-value">
                <el-radio-group v-model="formData.speedMode">
                  <el-radio label="STANDARD">标准投放</el-radio>
                  <el-radio label="FAST">加速投放</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">计划日预算：</span>
              <div class="form-value">
                <el-radio-group v-model="formData.budgetMode">
                  <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                  <el-radio label="BUDGET_MODE_DAY">指定日预算</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-show="formData.budgetMode === 'BUDGET_MODE_DAY'" style="margin-bottom: 0px">
              <span class="form-label"></span>
              <div class="form-value">
                <el-form-item prop="dailyBudget">
                  <el-input style="width: 264px" placeholder="(必填) 50元 - 40,000,000元" v-model="formData.dailyBudget">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">总预算：</span>
              <div class="form-value">
                <el-radio-group v-model="formData.totalBudgetMode">
                  <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                  <el-radio label="BUDGET_MODE_DAY">指定总预算</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item" v-show="formData.totalBudgetMode === 'BUDGET_MODE_DAY'" style="margin-bottom: 0px">
              <span class="form-label"></span>
              <div class="form-value">
                <el-form-item prop="totalBudget">
                  <el-input style="width: 264px" placeholder="(必填) 50元 - 40,000,000元" v-model="formData.totalBudget">
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
          </div>
          <div v-else>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px"></span>
              <div class="form-value">
                <el-table :data="formData.onlineCampaign" style="width: 602px" border size="mini">
                  <el-table-column prop="company" label="广告账户" width="300">
                    <template slot-scope="scope">
                      <div>{{ scope.row.company }}</div>
                      <div>ID：{{ scope.row.accountId }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="推广计划" width="300">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.campaignId" placeholder="请选择已有推广计划" filterable>
                        <el-option
                          v-for="item in tablePlanOptions[scope.row.accountId]"
                          :key="item.campaignId"
                          :label="item.campaignName"
                          :value="item.campaignId"
                        >
                        </el-option>
                      </el-select>
                      <el-tooltip
                        style="margin-left: 20px"
                        class="item"
                        effect="dark"
                        content="不支持旧版微信朋友圈推广计划"
                        placement="top-start"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </li>
          </div>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCampaignList } from "@/api/promotion-gdt.js";
import nameTransforUtil from "./common/nameTransforUtil.js";
import SelectInput from "./common/selectInput.vue";
export default {
  components: {
    SelectInput,
  },
  data() {
    return {
      dialogVisible: true, //是否展示新建表单
      selectItem: [],
      tablePlanOptions: {},
      adGroupList: ["推广目标", "应用名称", "创建日期", "计划日预算", "投放方式", "版位", "用户名"],
      showMore: true,
      formData: {
        promotedObjectType: "APP_IOS",
        budgetMode: "BUDGET_MODE_DAY",
        totalBudgetMode: "BUDGET_MODE_DAY",
        campaignMode: "add",
        dailyBudget: "",
        totalBudget: "",
        nameRule: "",
        speedMode: "STANDARD",
        onlineCampaign: [],
      },
      rules: {
        dailyBudget: [{ validator: this.checkBudget, trigger: ["blur", "change"] }],
        totalBudget: [{ validator: this.checkBudget, trigger: ["blur", "change"] }],
        nameRule: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === "" && this.dialogVisible === true) {
                callback(new Error("推广计划名称必填"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    // 获取已有推广计划下拉列表
    getPlanOptions(id) {
      this.$nextTick(() => {
        getCampaignList({
          accountIds: [id],
          promotedObjectType: this.promotedObjectType,
        }).then((res) => {
          this.$set(this.tablePlanOptions, id, res.data);
        });
      });
    },
    checkBudget(rule, value, callback) {
      if (
        this.dialogVisible === false ||
        this.formData.budgetMode === "BUDGET_MODE_INFINITE" ||
        this.formData.totalBudgetMode === "BUDGET_MODE_INFINITE"
      ) {
        callback();
      } else if (value === "") {
        callback(new Error("请输入预算"));
      } else if (!/^[0-9]*$/.test(value) || Number(value) < 50 || Number(value) > 40000000) {
        callback(new Error("请输入不小于50且不大于40000000的数字"));
      } else {
        callback();
      }
    },
    handleSelectItem(item, itemIndex) {
      let index = this.selectItem.findIndex((item) => item === itemIndex);
      if (index === -1) {
        this.selectItem.push(itemIndex);
        this.formData.nameRule += "{" + item + "}";
      } else {
        this.selectItem.splice(index, 1);
        this.formData.nameRule = this.formData.nameRule.replace("{" + item + "}", "");
      }
    },
    changeSpreadTarget() {
      this.$store.commit("set_basic_draft_adset_promotedId_gdt", {
        promotedObjectId: "",
        promotedObjectName: "",
        channelPackageItems: [],
      });
      this.formData.onlineCampaign = [];
      this.adCount.map((item) => {
        this.formData.onlineCampaign.push({
          accountId: item.advertiserId,
          company: item.company,
          campaignId: "",
        });
      });
      this.$store.commit("set_spread_target_gdt", this.formData.promotedObjectType);
    },
    changeCampaignMode() {
      if (this.formData.campaignMode === "edit") {
        this.formData.onlineCampaign = [];
        this.adCount.map((item) => {
          this.formData.onlineCampaign.push({
            accountId: item.advertiserId,
            company: item.company,
            campaignId: "",
          });
        });
      }
      this.$store.commit("set_draft_campaign_mode_gdt", this.formData.campaignMode);
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.selectInputRef.checkData(),
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              if (this.dialogVisible) {
                //保存新建的推广表单数据到store
                const {
                  campaignMode,
                  promotedObjectType,
                  nameRule,
                  speedMode,
                  dailyBudget,
                  budgetMode,
                  totalBudget,
                  totalBudgetMode,
                  onlineCampaign,
                } = this.formData;
                let parmas = {
                  accountIds: this.adCount.map((item) => item.advertiserId),
                  promotedObjectType,
                  nameRule: nameTransforUtil.showDataToApi(nameRule),
                  speedMode,
                  campaignType: "NORMAL", // 该参数未确定是如何判断
                  dailyBudget: budgetMode === "BUDGET_MODE_INFINITE" ? 0 : dailyBudget * 100,
                  totalBudget: totalBudgetMode === "BUDGET_MODE_INFINITE" ? 0 : totalBudget * 100,
                  onlineCampaign: campaignMode === "add" ? [] : onlineCampaign,
                  campaignMode,
                };
                //保存到store
                this.$store.commit("set_draft_campaign_gdt", parmas);
              } else {
                //添加广告账户数据到已有广告组数据中
                let online_campaign = JSON.parse(JSON.stringify(this.draft_campaign.online_campaign));
                this.$store.commit("set_draft_campaign_gdt", {
                  online_campaign: online_campaign,
                });
              }
              resolve();
            } else {
              reject();
            }
          });
      });
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.adGroupList.slice(0, 5);
      }
      return this.adGroupList;
    },
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount,
      promotedObjectType: (state) => state.PromotionGdt.promotedObjectType,
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      draft_campaign: (state) => state.PromotionGdt.draft_campaign,
    }),
    changeData() {
      return { advertiserIdList: this.advertiserIdList, campaignMode: this.formData.promotedObjectType };
    },
  },
  watch: {
    changeData(val) {
      const { advertiserIdList } = val;
      if (advertiserIdList.length > 0) {
        advertiserIdList.map((item) => {
          this.getPlanOptions(item);
        });
      }
    },
    adCount(val) {
      if (val.length > 0) {
        this.formData.onlineCampaign = [];
        val.map((item) => {
          this.formData.onlineCampaign.push({
            accountId: item.advertiserId,
            company: item.company,
            campaignId: "",
          });
        });
      }
    },
    draft_campaign(value) {
      if (value) {
        const storeData = JSON.parse(JSON.stringify(value));
        this.formData = storeData;
        const { onlineCampaign, nameRule, dailyBudget, totalBudget } = storeData;
        this.$set(this.formData, "campaignMode", onlineCampaign?.length === 0 ? "add" : "edit");
        this.$set(this.formData, "nameRule", nameTransforUtil.apiDatatoShow(nameRule));
        this.$set(this.formData, "budgetMode", dailyBudget === 0 ? "BUDGET_MODE_INFINITE" : "BUDGET_MODE_DAY");
        this.$set(this.formData, "totalBudgetMode", totalBudget === 0 ? "BUDGET_MODE_INFINITE" : "BUDGET_MODE_DAY");
        this.$set(this.formData, "nameRule", nameTransforUtil.apiDatatoShow(nameRule));
        this.$set(this.formData, "dailyBudget", dailyBudget / 100);
        this.$set(this.formData, "totalBudget", totalBudget / 100);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ad-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .newgroup-wrap,
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/.el-form-item__error {
          top: 11px;
          left: 280px;
        }
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 108px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          .list-wrap {
            max-height: 120px;
            overflow: auto;
            .adCountItem {
              height: 22px;
              line-height: 22px;
              border-radius: 2px;
              display: inline-block;
              padding: 0 8px;
              margin: 0 8px 8px 0;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.65);
              .close-btn {
                display: inline-block;
                margin-left: 6px;
                font-size: 18px;
                cursor: pointer;
                position: relative;
                top: 1px;
              }
            }
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .name-list {
            padding: 12px 0px 0px 0px;
            margin: 0px;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            .name-item {
              border-radius: 2px;
              border: 1px solid transparent;
              box-sizing: border-box;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.85);
              font-size: 12px;
              padding: 2px 6px;
              margin: 0 8px 8px 0px;
              cursor: pointer;
              &.cur {
                border: 1px solid rgba(24, 144, 255, 1);
                background: rgba(225, 240, 255, 1);
                color: rgba(24, 144, 255, 1);
              }
            }
            .show-more {
              color: rgba(24, 144, 255, 1);
              font-size: 13px;
              cursor: pointer;
              margin-left: 20px;
              line-height: 24px;
              i {
                margin-left: 4px;
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
    .transfer-wrap {
      display: flex;
      margin-bottom: 24px;
      .top-list {
        width: 250px;
        border: 1px solid #ebeef5;
        .list-header {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          padding: 10px 0px 10px 12px;
          border-bottom: 1px solid #ebeef5;
        }
        .count-list {
          overflow: auto;
          height: 316px;
          padding: 0px;
          margin: 0px;
          list-style: none;
          .count-item {
            cursor: pointer;
            padding: 6px 10px;
            position: relative;
            .item-detial {
              display: block;
              font-size: 12px;
              color: #666;
            }
            &.cur {
              background-color: rgba(230, 247, 255, 1);
            }
          }
          .item-count {
            position: absolute;
            right: 10px;
            top: 11px;
            width: 17px;
            height: 17px;
            border-radius: 3px;
            background: rgba(24, 144, 255, 1);
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            text-align: center;
            line-height: 17px;
          }
        }
      }
      /deep/ .el-checkbox {
        margin-right: 0px;
      }
    }
  }
}
</style>
